// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";

export const formTextArea = css`
    height: 174px !important;
    padding: 25px !important;
`;
